import type { StoreApi } from 'zustand'

import type { ToastActions, ToastItem, ToastStore } from './types'

type SetState = StoreApi<ToastStore>['setState']
type GetState = StoreApi<ToastStore>['getState']

const DEFAULT_DURATION_MS = 5000

const generateToastId = (): string => `toast-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`

export const createToastActions = (set: SetState, get: GetState): ToastActions => ({
  showToast: (toast) => {
    const id = generateToastId()
    const newToast: ToastItem = {
      id,
      variant: 'success',
      duration: DEFAULT_DURATION_MS,
      position: 'bottom-right',
      ...toast,
    }

    set((state) => ({ toasts: [...state.toasts, newToast] }))

    if (newToast.duration && newToast.duration > 0) {
      setTimeout(() => get().removeToast(id), newToast.duration)
    }

    return id
  },

  removeToast: (id) => {
    set((state) => ({ toasts: state.toasts.filter((toast) => toast.id !== id) }))
  },
})
